import { render, staticRenderFns } from "./MutabakatDeadlineBanner.vue?vue&type=template&id=742d462c&scoped=true&"
import script from "./MutabakatDeadlineBanner.vue?vue&type=script&lang=js&"
export * from "./MutabakatDeadlineBanner.vue?vue&type=script&lang=js&"
import style0 from "./MutabakatDeadlineBanner.vue?vue&type=style&index=0&id=742d462c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742d462c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
